// generated by Neptune Namespaces v4.x.x
// file: Art.ClassSystem/index.js

(module.exports = require('./namespace'))
.includeInNamespace(require('./ClassSystem'))
.addModules({
  BaseClass:               require('./BaseClass'),
  BaseObject:              require('./BaseObject'),
  DeclarableMixin:         require('./DeclarableMixin'),
  ExtendablePropertyMixin: require('./ExtendablePropertyMixin'),
  WebpackHotLoader:        require('./WebpackHotLoader')
});